// extracted by mini-css-extract-plugin
export default {"rating":"GV-z","numberOfStars":"HV-z","count":"IV-z","barGraphSpacing":"JV-z","barGraph":"KV-z"};